if (!customElements.get('tmf-service-orbit')) {
  class TmfServiceOrbit extends HTMLElement {
    constructor() {
      super();
      this.section = null;
      this.visibilityObserver = null;
      this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.motionEnabled = true;

      this.handleDocumentVisibility = this.handleDocumentVisibility.bind(this);
      this.handleReducedMotion = this.handleReducedMotion.bind(this);
      this.handleVisibility = this.handleVisibility.bind(this);
    }

    connectedCallback() {
      this.cleanup();

      this.section = this.querySelector('[data-service-orbit-section]');
      this.motionEnabled = this.dataset.motionEnabled !== 'false';

      if (!this.section) return;

      document.addEventListener('visibilitychange', this.handleDocumentVisibility);
      this.reducedMotion.addEventListener?.('change', this.handleReducedMotion);
      this.updateMotionState();
    }

    disconnectedCallback() {
      this.cleanup();
    }

    cleanup() {
      document.removeEventListener('visibilitychange', this.handleDocumentVisibility);
      this.reducedMotion?.removeEventListener?.('change', this.handleReducedMotion);
      this.visibilityObserver?.disconnect();
      this.visibilityObserver = null;
    }

    updateMotionState() {
      this.visibilityObserver?.disconnect();
      this.visibilityObserver = null;

      if (!this.motionEnabled || this.reducedMotion.matches) {
        this.dataset.orbitVisible = 'false';
        return;
      }

      if (!('IntersectionObserver' in window)) {
        this.updateVisibleState();
        return;
      }

      this.visibilityObserver = new IntersectionObserver(this.handleVisibility, {
        root: null,
        rootMargin: '0px',
        threshold: 0.05,
      });
      this.visibilityObserver.observe(this.section);
    }

    handleVisibility(entries) {
      const isIntersecting = entries[0]?.isIntersecting ?? false;
      this.dataset.orbitVisible = String(
        isIntersecting && !document.hidden && this.motionEnabled && !this.reducedMotion.matches
      );
    }

    handleDocumentVisibility() {
      this.updateVisibleState();
    }

    handleReducedMotion() {
      this.updateMotionState();
    }

    updateVisibleState() {
      if (!this.section) return;

      const rect = this.section.getBoundingClientRect();
      const isIntersecting = rect.top < window.innerHeight && rect.bottom > 0;
      this.dataset.orbitVisible = String(
        isIntersecting && !document.hidden && this.motionEnabled && !this.reducedMotion.matches
      );
    }
  }

  customElements.define('tmf-service-orbit', TmfServiceOrbit);
}
